// Module
var code = `<template> <rightship-data-grid item-source.bind="itemSource" selection-mode.bind="selectionMode" sorting-enabled="true" view-model.ref="dataGridVM"></rightship-data-grid> </template>`;
// Exports
module.exports = code;